const randomString = (type: 1 | 2 | 3, length: number) => {
  //* Type: 1/2; Độ dài ghi gen password
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'; //* Type: 1
  var chars_2 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'; //* Type: 2
  var chars_3 = '0123456789'; //* Type: 2
  var originChars = chars; //
  var randomString = ''; //? value default password
  if (type === 1) {
    originChars = chars;
  } else if (type === 2) {
    originChars = chars_2;
  } else if (type === 3) {
    originChars = chars_3;
  }
  for (var i = 1; i <= length; i++) {
    var randomNumber = Math.floor(Math.random() * originChars.length);
    randomString += originChars.substring(randomNumber, randomNumber + 1);
  }
  return randomString;
};

export { randomString };
